import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import { Layout, Menu } from "antd";
import style from "./Sidebar.module.css";
import api from "../../utils/Api";
import history from "../../utils/history";
import swal from "sweetalert";
import sidebarDashboard from "../../assets/images/sidebar-dashboard.svg";
import sidebarApprovals from "../../assets/images/sidebar-approvals.svg";
import sidebarUsers from "../../assets/images/sidebar-users.svg";
import sidebarSettings from "../../assets/images/sidebar-settings.svg";
import sidebarRoom from "../../assets/images/sidebar-rooms-venue.svg";
import deletedEntriesIc from "../../assets/images/deleted-entries-icon.svg";
import archievedAppIc from "../../assets/images/archive-approvals-icon.svg";
import createAppIc from "../../assets/images/create-appointment-icon.svg";
import blockTimeIc from "../../assets/images/block-time-icon.svg";
import appListIc from "../../assets/images/appointments-list-icon.svg";
import relatedPartiesIc from "../../assets/images/related-parties-icon.svg";
import addRelatedPartiesIc from "../../assets/images/add-related-party-icon.svg";
import myAccountIc from "../../assets/images/my-account-icon.svg";
import editAccountIc from "../../assets/images/edit-account-icon.svg";
import logoutIc from "../../assets/images/logout-icon.svg";
import inventoryIc from "../../assets/images/inventory.svg";
import addSupplyIc from "../../assets/images/add-supply-icon.svg";
import inventoryListIc from "../../assets/images/inventory-list.svg";
import relatedPartiesListIc from "../../assets/images/related-parties-list-icon.svg";
import appoinmentListIc from "../../assets/images/appointment-list-icon.svg";
import inventorySumm from "../../assets/images/inventory-summary.svg";
import subategoryIc from "../../assets/images/sub-category-icon.svg";
import subCatListIc from "../../assets/images/subcategories-list-icon.svg";
import inventoryAuditTrailIc from "../../assets/images/inventory-audit-trail-icon.svg";
import sendPaymentIc from "../../assets/images/sent-payments-icon.svg";
import receivePaymentsIc from "../../assets/images/receive-payments-icon.svg";
//import paymentHistoryIc from "../../assets/images/payments-history-icon.svg";
import generalSettingIc from "../../assets/images/general-settings-icon.svg";
import picklistSettingIc from "../../assets/images/picklist-settings-icon.svg";
import practiceComIc from "../../assets/images/practice-compliance-icon.svg";
import auditTrailIc from "../../assets/images/audit-trall-icon.svg";
import reportIc from "../../assets/images/report-icon.svg";
import notificationIc from "../../assets/images/notification-icon.svg";
import paymentsIc from "../../assets/images/payments-icon.svg";
import addPatientIc from "../../assets/images/add-patient-icon.svg";
import claimSettingsIc from "../../assets/images/claim-settings-icon.svg";
import createInvoiceIc from "../../assets/images/create-invoice-icon.svg";
import invoiceListIc from "../../assets/images/invoice-list-icon.svg";
import otherReportsIc from "../../assets/images/other-reports-icon.svg";
import patientIc from "../../assets/images/patient-icon.svg";
import patientListIc from "../../assets/images/patient-list-icon.svg";
import paymentHistoryIc from "../../assets/images/payment-history-icon.svg";
import smsTemplateIc from "../../assets/images/sms-template-icon.svg";
import statementsIc from "../../assets/images/statements-icon.svg";
import userRolesIc from "../../assets/images/user-roles-icon.svg";
import { checkIfPermitted } from "../../services/RolePermissionService";
import { fetchNotificationsListing, switchRoles, fetchUserDetails } from '../../redux';
import Permissions from "../../utils/PermissionKeys.json";
import { listenSocketEvents, socketDisconnect } from "../../services/SocketServices";
import { connect } from "react-redux";
import { checkSession } from "../../services/CheckSessionService";
//import store from '../redux/store';

const { Sider } = Layout;
const { SubMenu } = Menu;

const menubarItems = [{
  subMenuKey: "sub11",
  link: "/app/patients"
},{
  subMenuKey: "sub1",
  link: "/app/contacts"
},{
  subMenuKey: "sub1",
  link: "/app/editcontact"
},{
  subMenuKey: "sub11",
  link: "/app/editpatient"
},{
  subMenuKey: "sub1",
  link: "/app/parties-delete-entries"
},{
  subMenuKey: "sub1",
  link: "/app/pendingapprovallist"
},{
  subMenuKey: "sub1",
  link: "/app/archivedapprovallist"
},{
  subMenuKey: "sub3",
  link: "/app/appoinmentlist"
},{
  subMenuKey: "sub3",
  link: "/app/createappointment"
},{
  subMenuKey: "sub3",
  link: "/app/blocktime"
},{
  subMenuKey: "sub3",
  link: "/app/roomlist"
},{
  subMenuKey: "sub3",
  link: "/app/procedureslist"
},{
  subMenuKey: "sub3",
  link: "/app/appointmentscalendar"
},{
  subMenuKey: "sub3",
  link: "/app/medicalnotes"
},{
  subMenuKey: "sub4",
  link: "/app/sendpayment"
},{
  subMenuKey: "sub4",
  link: "/app/receivepayment"
},{
  subMenuKey: "sub4",
  link: "/app/paymenthistory"
},{
  subMenuKey: "sub4",
  link: "/app/createinvoicesupplier"
},{
  subMenuKey: "sub4",
  link: "/app/invoicelist"
},{
  subMenuKey: "sub6",
  link: "/app/inventorysummery"
},{
  subMenuKey: "sub6",
  link: "/app/addsupply"
},{
  subMenuKey: "sub6",
  link: "/app/inventorylist"
},{
  subMenuKey: "sub6",
  link: "/app/addsubcategory"
},{
  subMenuKey: "sub6",
  link: "/app/subcategorieslist"
},{
  subMenuKey: "sub6",
  link: "/app/inventoryaudit"
},{
  subMenuKey: "sub8",
  link: "/app/users"
},{
  subMenuKey: "sub8",
  link: "/app/userrolelist"
},{
  subMenuKey: "sub10",
  link: "/app/audittrail"
},{
  subMenuKey: "sub10",
  link: "/app/statements"
},{
  subMenuKey: "sub10",
  link: "/app/reportsIncome"
},{
  subMenuKey: "sub8",
  link: "/app/generalsetting"
},{
  subMenuKey: "sub8",
  link: "/app/settings"
},{
  subMenuKey: "sub8",
  link: "/app/claimsettings"
},{
  subMenuKey: "sub8",
  link: "/app/templates"
},{
  subMenuKey: "sub9",
  link: "/app/practicecompliance"
},{
  subMenuKey: "sub9",
  link: "/app/editaccount"
}];

const events = [
  "load",
  "mousemove",
  "mousedown",
  "click",
  "scroll",
  "keypress",
];
let logoutTimeout = null;
class Sidebar extends Component {
  constructor(props) {
    super(props);
    this.rootSubmenuKeys = ['sub1', 'sub3', 'sub4', 'sub6', 'sub8', 'sub9', 'sub10', 'sub11'];
    this.state = {
      collapsed: true,
      approver: "",
      first_name: "",
      last_name: "",
      system_access: "",
      primary_system_role: "",
      assigned_roles: "",
      openKeys:[],
      systemRole: localStorage.getItem("USER_INFO") &&
      JSON.parse(localStorage.getItem("USER_INFO")).systemRole,
      isLoggedInUser:
        localStorage.getItem("USER_INFO") &&
        JSON.parse(localStorage.getItem("USER_INFO")).isLoggenIn,
      name:
        localStorage.getItem("USER_INFO") &&
        JSON.parse(localStorage.getItem("USER_INFO")).name,
      role:
        localStorage.getItem("USER_INFO") &&
        JSON.parse(localStorage.getItem("USER_INFO")).role,
    };
    this.logoutTimeout = null;
    
  }

  componentWillUnmount(){

    for (var i in events) {
      window.removeEventListener(events[i], this.resetTimeout);
    }
    this.clearTimeoutTimer();
  }

  onCollapse = (collapsed) => {
    this.setState({ collapsed });
    this.props.sendData(collapsed);
  };

  componentDidMount = async()=> {
 //listen socket events
  listenSocketEvents();
    for (var i in events) {
      window.addEventListener(events[i], this.resetTimeout);
    }
    // let user_id = 
    // localStorage.getItem("USER_INFO") &&
    // JSON.parse(localStorage.getItem("USER_INFO")).user_id;
    let userInfo = localStorage.getItem("USER_INFO") &&
    JSON.parse(localStorage.getItem("USER_INFO"));
    await this.props.fetchUserDetails(userInfo.user_id);

        if(!this.props.userDetailsData.loading && this.props.userDetailsData.error === ""){
            let userDetails = this.props.userDetailsData.userDetails;
            if(userDetails){
            this.setState({
                first_name: userDetails && userDetails.first_name,
                last_name: userDetails && userDetails.last_name,
                system_access: userDetails && userDetails.isSystemUser,
                approver: userDetails && userDetails.approver,
                primary_system_role: userDetails && userDetails.role_id,
                assigned_roles: userDetails && userDetails.assigned_roles
            })
            // let userInfo = localStorage.getItem("USER_INFO") &&
            // JSON.parse(localStorage.getItem("USER_INFO"));
            const dropdownListData = this.props.dropdownListData.dropdownList;
            const role = dropdownListData && dropdownListData.role &&
            dropdownListData.role.find((opt, index) => (
              opt.role_id === userDetails.role_id && parseInt(userDetails.role_id)
            ));
            if(role && role.role_name){
              userInfo.role = role.role_name;
            }
            userInfo.systemRole =  userDetails.role_id && parseInt(userDetails.role_id);
            userInfo.approver = userDetails && userDetails.approver;
            localStorage.setItem("USER_INFO", JSON.stringify(userInfo));
            }
        }else if(!this.props.userDetailsData.loading && this.props.userDetailsData.error === "Network Error"){
          this.logout();
          return false;
        }

    this.setTimeoutTimer();
    // Calling fetch picklist options method
    this.getGeneralSetting();
    this.props.fetchNotificationsListing();
    

    let path = this.props.location.pathname;
    const subMenuKeyObj = menubarItems.find(key => path.includes(key.link));
    
    if(subMenuKeyObj){
      this.setState({
        openKeys: [subMenuKeyObj.subMenuKey],
      });
    }

  }

  // fetching general setting options
  getGeneralSetting = async () => {
    const headers = {
      Authorization:
        "Bearer " + JSON.parse(localStorage.getItem("USER_INFO")).token,
    };
    try {
      const response = await api.get("setting/fetch", {
        headers: headers,
      });
     // console.log("Getting response data for general setting - ", response);

      // Save settings data in locale storage
      const settings = {
        max_upload: response.data.data.setting.max_upload,
        max_product_image_upload:
          response.data.data.setting.max_product_image_upload,
        vat_percent: response.data.data.setting.vat_percent,
        max_paymentproof_upload:
          response.data.data.setting.max_paymentproof_upload,
      };

      localStorage.setItem("SETTING_INFO", JSON.stringify(settings));
    } catch (error) {
      console.log("Error", error);
      this.setState({
        isDataFetching: false,
      });
    }
  };

  clearTimeoutTimer = () => {
    if (logoutTimeout) {
      clearTimeout(logoutTimeout);
      logoutTimeout = null;
    }
  };

  setTimeoutTimer = () => {
    logoutTimeout = setTimeout(()=>
      (this.state.isLoggedInUser && this.autologout),
      90 * 10000
    );
  };

  resetTimeout = () => {
    //console.log("login", this.props)
    checkSession();
    this.clearTimeoutTimer();
    this.setTimeoutTimer();
  };

  logout = async () => {
    const token =
      localStorage.getItem("USER_INFO") &&
      JSON.parse(localStorage.getItem("USER_INFO")).token;
    // Headers
    const headers = {
      Authorization: "Bearer " + token,
    };
    try {
      const response = await api.post("user/logout", {}, { headers: headers });
      if (response.status === 200) {
        this.setState({
          isLoggedInUser: false,
        });
        localStorage.clear("USER_INFO");
        socketDisconnect();
        history.push("/");
      }
    } catch (e) {
      this.setState({
        isLoggedInUser: false,
      });
      localStorage.clear("USER_INFO");
      socketDisconnect();
      history.push("/");
      console.log("Error in logout response", e);
    }
  };

  logoutClick = async () => {
    const shouldLogout = await swal("Are you sure you want to logout?", {
      className: "logout-swal-modal",
      buttons: ["Cancel", "Yes"],
    });
    if (shouldLogout) {
      this.logout();
    }
  };

  autologout = async () => {
    if (this.state.isLoggedInUser) {
      setTimeout(() => {
        this.logout();
      }, 1000);
      swal("Session expired. Please login again.", {
        className: "autologout-swal-modal",
      });
    }
  };

  onOpenChange = openKeys => {
    const latestOpenKey = openKeys.find(key => this.state.openKeys.indexOf(key) === -1);
    if (this.rootSubmenuKeys.indexOf(latestOpenKey) === -1) {
      this.setState({ openKeys });
    } else {
      this.setState({
        openKeys: latestOpenKey ? [latestOpenKey] : [],
      });
    }
  };
  onOpenSelect= (data) => {
    if(data.key ==="/app/dashboard"){
      this.setState({
        openKeys: [],
      });
    }
  }

  handleRoleChange = async (event) => {
   // console.log("role", event.target.value)
    let role_id = event.target.value;
    swal("Please wait...", {
      className: "autologout-swal-modal",
      buttons: false,
    });
    await this.props.switchRoles(parseInt(role_id));

    if(!this.props.switchRolesData.loading && this.props.switchRolesData.switchRoles ){
      let switchRoleData = this.props.switchRolesData.switchRoles;
      let userInfo = localStorage.getItem("USER_INFO") &&
      JSON.parse(localStorage.getItem("USER_INFO"));
     
      userInfo.systemRole = parseInt(role_id);
      const dropdownListData = this.props.dropdownListData.dropdownList;
        const role = dropdownListData && dropdownListData.role &&
        dropdownListData.role.find((opt, index) => (
          opt.role_id === parseInt(role_id)
        ));

      userInfo.role = role.role_name;
      userInfo.token = switchRoleData.token;
      localStorage.setItem("USER_INFO", JSON.stringify(userInfo));
      window.location.reload();
    }

  }


  render() {
    const { location } = this.props;
    //console.log("*********** Location *******", location);

   const notificationsData = this.props.notificationsData && this.props.notificationsData.notifications;
   const dropdownListData = this.props.dropdownListData.dropdownList;
   const systemRoleOptions = dropdownListData && dropdownListData.role &&
   dropdownListData.role.filter((opt) => opt.role_id !== 1)
   .map((opt, index) => (
     <option key={index} value={opt.role_id}>
       {opt.role_name}
     </option>
   ));

   const primarySystemRoleOptions = 
   dropdownListData && dropdownListData.role &&
    dropdownListData.role.map((element, index) => {
     if(this.state.assigned_roles &&
      this.state.assigned_roles.length > 0 
      && this.state.assigned_roles.indexOf(element.role_id) > -1){
        return (
        <option key={index} value={element.role_id}>
          {element.role_name}
        </option>
        )
     }
    });

   const approver = 
   localStorage.getItem("USER_INFO") &&
   JSON.parse(localStorage.getItem("USER_INFO")).approver;
    const system_role =
      localStorage.getItem("USER_INFO") &&
      JSON.parse(localStorage.getItem("USER_INFO")).systemRole;
    return (
      <Layout style={{ minHeight: "100vh" }} className={`d-print-none ${style.techtomedSidebar}`}>
        <Sider
          breakpoint="lg"
          collapsible
          collapsed={this.state.collapsed}
          onCollapse={this.onCollapse}
          width={270}
        >
          <Menu
            defaultSelectedKeys={["/"]}
            selectedKeys={[location.pathname]}
            openKeys={this.state.openKeys}
            onOpenChange={this.onOpenChange}
            onSelect={this.onOpenSelect}
            mode="inline"
          >
            <div className="d-flex" >
              <Link className={style.notificationLink} to="/app/notificationsboard">
                <div className={`collapse-entryBtn justify-content-center ${style.notificationBtn}`}>
                  <img src={notificationIc} title="Notifications" alt="notification-icon" width="16" />
                   {(notificationsData && parseInt(notificationsData.unreadCount) > 0 ) && (
                     <span class={style.buttonBadge}>{notificationsData.unreadCount}</span>
                   )}
                </div>
              </Link>
              <div className="d-block">
              <div className={`collapse-entryBtn ${style.addEntryBtn}`}>
                <div className={style.nameRoleWrapper}>
                  <p className={style.hello}>Hello,</p>
                  <h6>{this.state.name}</h6>
                  {this.state.assigned_roles.length === 1 && (
                    <p>{this.state.role}</p>
                    )}
                  {this.state.systemRole !== 1 && this.state.assigned_roles.length > 1 && (
                  <select
                      name="systemRole"
                      onChange={this.handleRoleChange}
                      value={this.state.primary_system_role}
                      className={ `form-control switch-roles-select`}
                      >
                      {primarySystemRoleOptions}
                    </select>)}
                </div>
              </div>
                </div>
            </div>
            
            {/* {this.state.systemRole !== 1 && this.state.assigned_roles.length > 1 && (
            <div className="row">
               <div className="col-md-12 ml-3 mb-3 menu-link">
                    <label>
                      Switch Roles
                    </label>
                    <select
                      name="systemRole"
                      onChange={this.handleRoleChange}
                      value={this.state.primary_system_role}
                      className={ `form-control switch-roles-select`}
                      >
                      {primarySystemRoleOptions}
                    </select>
                </div>
            </div>)} */}
            <Menu.Item key="/app/dashboard">
              <Link
                to="/app/dashboard"
                className={`linkSideNav ${style.sideNavLink}`}
              >
                <div class="d-flex">
                  <div class="d-flex justify-content-center icon-wrapper">
                    <img src={sidebarDashboard} 
                    class={style.sidebarIcon} alt="Home" width="16"/>
                    </div>
                  <span class="menu-link">Home</span>
                </div>
              </Link>
            </Menu.Item>
            {(checkIfPermitted(Permissions.VIEW_PATIENTS_LIST) || 
            checkIfPermitted(Permissions.CREATE_PATIENTS)) && (
             <SubMenu
              key="sub11"
              title={
                <div class={`d-flex ${style.collpaseOpacity}`}>
                  <div class="d-flex justify-content-center icon-wrapper">
                    <img src={patientIc} 
                    class={style.sidebarIcon} alt="Patients" width="16" />
                    </div>
                  <span class="menu-link">Patients</span>
                </div>
              }
            >
            {checkIfPermitted(Permissions.VIEW_PATIENTS_LIST) && (
                  <Menu.Item key="/app/patients">
                    <Link
                      to="/app/patients"
                      className={`linkSideNav ${style.sideNavLink}`}
                    >
                      <div class={`d-flex ${style.collpaseOpacity}`}>
                      <div class="d-flex justify-content-center icon-wrapper">
                        <img src={patientListIc} 
                        class={style.sidebarIcon} alt="Patients list" width="18" />
                        </div>
                      <span class="menu-link">Patients List</span>
                    </div>
                    </Link>
                  </Menu.Item>
                  )}
                  { checkIfPermitted(Permissions.CREATE_PATIENTS) && (
                <Menu.Item key="/app/editpatient">
                  <Link
                    to="/app/editpatient"
                    className={`linkSideNav ${style.sideNavLink}`}
                   >
                    <div class={`d-flex ${style.collpaseOpacity}`}>
                      <div class="d-flex justify-content-center icon-wrapper">
                        <img src={addPatientIc} 
                        class={style.subMenuIcon} 
                        alt="create patient" width="18" />
                        </div>
                      <span class="menu-link">Add Patient
                      </span>
                    </div>
                  </Link>
                </Menu.Item>
              )}
            </SubMenu>)}
            <SubMenu
              key="sub1"
              title={
                <div class={`d-flex ${style.collpaseOpacity}`}>
                  <div class="d-flex justify-content-center icon-wrapper">
                    <img src={relatedPartiesIc} 
                    class={style.sidebarIcon} alt="Home" width="16" />
                    </div>
                  <span class="menu-link">Contacts</span>
                </div>
              }
            >
             
              {checkIfPermitted(Permissions.VIEW_CONTACTS_LIST) && (
                  <Menu.Item key="/app/contacts">
                    <Link
                      to="/app/contacts"
                      className={`linkSideNav ${style.sideNavLink}`}
                    >
                      <div class={`d-flex ${style.collpaseOpacity}`}>
                      <div class="d-flex justify-content-center icon-wrapper">
                        <img src={relatedPartiesListIc} 
                        class={style.sidebarIcon} alt="Contact list" width="18" />
                        </div>
                      <span class="menu-link">Contacts List</span>
                    </div>
                    </Link>
                  </Menu.Item>
                  )}
              { checkIfPermitted(Permissions.CREATE_CONTACTS) && (
                <Menu.Item key="/app/editcontact">
                  <Link
                    to="/app/editcontact"
                    className={`linkSideNav ${style.sideNavLink}`}
                   >
                    <div class={`d-flex ${style.collpaseOpacity}`}>
                      <div class="d-flex justify-content-center icon-wrapper">
                        <img src={addRelatedPartiesIc} 
                        class={style.subMenuIcon} 
                        alt="create contact" width="18" />
                        </div>
                      <span class="menu-link">Add Contact
                      </span>
                    </div>
                  </Link>
                </Menu.Item>
              )}
              
              <Menu.Item key="/app/parties-delete-entries">
                <Link
                  to="/app/parties-delete-entries"
                  className={`linkSideNav ${style.sideNavLink}`}
                >
                    <div class={`d-flex ${style.collpaseOpacity}`}>
                      <div class="d-flex justify-content-center icon-wrapper">
                        <img src={deletedEntriesIc} 
                        class={style.subMenuIcon} alt="Deleted Contacts" width="18" />
                        </div>
                      <span class="menu-link">Deleted Contacts</span>
                    </div>
                </Link>
              </Menu.Item>
              {this.state.approver == 1 && (
                <Menu.Item key="/app/pendingapprovallist">
                  <Link
                    to="/app/pendingapprovallist"
                    className={`linkSideNav ${style.sideNavLink}`}
                  >
                    <div class={`d-flex ${style.collpaseOpacity}`}>
                      <div class="d-flex justify-content-center icon-wrapper">
                        <img src={sidebarApprovals} 
                        class={style.subMenuIcon} alt="Pending Approvals" width="18" />
                        </div>
                      <span class="menu-link">Pending Approvals</span>
                    </div>
                   </Link>
                </Menu.Item>
              )}
              {system_role == 1 && (
                <Menu.Item key="/app/archivedapprovallist">
                  <Link
                    to="/app/archivedapprovallist"
                    className={`linkSideNav ${style.sideNavLink}`}
                  >
                    <div class={`d-flex ${style.collpaseOpacity}`}>
                      <div class="d-flex justify-content-center icon-wrapper">
                        <img src={archievedAppIc} 
                        class={style.subMenuIcon} alt="Archived Contacts" width="18" />
                        </div>
                      <span class="menu-link">Archived Contacts</span>
                    </div>
                   </Link>
                </Menu.Item>
              )}
            </SubMenu>

            
              <SubMenu
                key="sub3"
                title={
                  <div class={`d-flex ${style.collpaseOpacity}`}>
                  <div class="d-flex justify-content-center icon-wrapper">
                    <img src={appListIc} 
                    class={style.sidebarIcon} alt="Appointments" width="16" />
                    </div>
                  <span class="menu-link">Appointments</span>
                </div>
                }
              >
                <Menu.Item key="/app/appoinmentlist">
                  <Link
                    to="/app/appoinmentlist"
                    className={`linkSideNav ${style.sideNavLink}`}
                  >
                     <div class={`d-flex ${style.collpaseOpacity}`}>
                      <div class="d-flex justify-content-center icon-wrapper">
                        <img src={appoinmentListIc} 
                        class={style.subMenuIcon} alt="Appointment List" width="18" />
                        </div>
                      <span class="menu-link">Appointment List</span>
                    </div>
                  </Link>
                </Menu.Item>
                {checkIfPermitted(Permissions.CREATE_APPOINTMENT) && (
                <Menu.Item key="/app/createappointment">
                  <Link
                    to="/app/createappointment"
                    className={`linkSideNav ${style.sideNavLink}`}
                  >
                    <div class={`d-flex ${style.collpaseOpacity}`}>
                      <div class="d-flex justify-content-center icon-wrapper">
                        <img src={createAppIc} 
                        class={style.subMenuIcon} alt="Create Appointment" width="18" />
                        </div>
                      <span class="menu-link">Create Appointment</span>
                    </div>
                  </Link>
                </Menu.Item>)}
                <Menu.Item key="/app/blocktime">
                  <Link
                    to="/app/blocktime"
                    className={`linkSideNav ${style.sideNavLink}`}
                  >
                    <div class={`d-flex ${style.collpaseOpacity}`}>
                      <div class="d-flex justify-content-center icon-wrapper">
                        <img src={blockTimeIc} 
                        class={style.subMenuIcon} alt="Block Time" width="18" />
                        </div>
                      <span class="menu-link">Block Time</span>
                    </div>
                  </Link>
                </Menu.Item>
                <Menu.Item key="/app/roomlist">
                  <Link
                    to="/app/roomlist"
                    className={`linkSideNav ${style.sideNavLink}`}
                  >
                    <div class={`d-flex ${style.collpaseOpacity}`}>
                      <div class="d-flex justify-content-center icon-wrapper">
                        <img src={sidebarRoom} 
                        class={style.subMenuIcon} alt="Room List" width="18" />
                        </div>
                      <span class="menu-link">Room List</span>
                    </div>
                  </Link>
                </Menu.Item>
                {/* <Menu.Item key="/app/procedureslist">
                  <Link
                    to="/app/procedureslist"
                    className={`linkSideNav ${style.sideNavLink}`}
                  >
                    <div class={`d-flex ${style.collpaseOpacity}`}>
                      <div class="d-flex justify-content-center icon-wrapper">
                        <img src={sidebarProcedure} 
                        class={style.subMenuIcon} alt="Medical Procedure" width="18" />
                        </div>
                      <span class="menu-link">Medical Procedure</span>
                    </div>
                  </Link>
                </Menu.Item> */}
                {checkIfPermitted(Permissions.VIEW_CALENDAR) && (
                <Menu.Item key="/app/appointmentscalendar">
                  <Link
                    to="/app/appointmentscalendar"
                    className={`linkSideNav ${style.sideNavLink}`}
                  >
                    <div class={`d-flex ${style.collpaseOpacity}`}>
                      <div class="d-flex justify-content-center icon-wrapper">
                        <img src={appListIc} 
                        class={style.subMenuIcon} alt="Appointment Calendar" width="18" />
                        </div>
                      <span class="menu-link">Calendar</span>
                    </div>
                  </Link>
                </Menu.Item>)}
                {checkIfPermitted(Permissions.MANAGE_LETTERS) && (
                <Menu.Item key="/app/medicalnotes">
                  <Link
                    to="/app/medicalnotes"
                    className={`linkSideNav ${style.sideNavLink}`}
                  >
                    <div class={`d-flex ${style.collpaseOpacity}`}>
                      <div class="d-flex justify-content-center icon-wrapper">
                        <img src={practiceComIc} 
                        class={style.subMenuIcon} alt="Medical Notes" width="18" />
                        </div>
                      <span class="menu-link">Medical Notes</span>
                    </div>
                  </Link>
                </Menu.Item>)}
              </SubMenu>

            {(checkIfPermitted(Permissions.MAKE_PAYMENT) || 
            checkIfPermitted(Permissions.RECIEVE_PAYMENT) ||
            checkIfPermitted(Permissions.VIEW_PAYMENT_TRANSACTION) ||
            checkIfPermitted(Permissions.CAPTURE_INVOICE) ||
            checkIfPermitted(Permissions.VIEW_INVOICE) ) && (
              <SubMenu
                key="sub4"
                title={
                  <div class={`d-flex ${style.collpaseOpacity}`}>
                  <div class="d-flex justify-content-center icon-wrapper">
                    <img src={paymentsIc} 
                    class={style.sidebarIcon} alt="Payments" width="18" />
                    </div>
                  <span class="menu-link">Payments</span>
                </div>
                }
              >
               { checkIfPermitted(Permissions.MAKE_PAYMENT) && (
                <Menu.Item key="/app/sendpayment">
                    <Link
                      className={`linkSideNav ${style.sideNavLink}`}
                      to="/app/sendpayment"
                    >
                      <div class={`d-flex ${style.collpaseOpacity}`}>
                      <div class="d-flex justify-content-center icon-wrapper">
                        <img src={sendPaymentIc} 
                        class={style.subMenuIcon} alt="Make Payments" width="22" />
                        </div>
                      <span class="menu-link">Make Payment</span>
                    </div>
                    </Link>
                  </Menu.Item>
                )}
                { checkIfPermitted(Permissions.RECIEVE_PAYMENT) &&(
                <Menu.Item key="/app/receivepayment">
                  <Link
                    to="/app/receivepayment"
                    className={`linkSideNav ${style.sideNavLink}`}
                  >
                    <div class={`d-flex ${style.collpaseOpacity}`}>
                      <div class="d-flex justify-content-center icon-wrapper">
                        <img src={receivePaymentsIc} 
                        class={style.subMenuIcon} alt="Receive Payments" width="22" />
                        </div>
                      <span class="menu-link">Receive Payment</span>
                    </div>
                  </Link>
                </Menu.Item>)}
                { checkIfPermitted(Permissions.VIEW_PAYMENT_TRANSACTION) && (
                <Menu.Item key="/app/paymenthistory">
                  <Link
                    className={`linkSideNav ${style.sideNavLink}`}
                    to="/app/paymenthistory"
                  >
                     <div class={`d-flex ${style.collpaseOpacity}`}>
                      <div class="d-flex justify-content-center icon-wrapper">
                        <img src={paymentHistoryIc} 
                        class={style.subMenuIcon} alt="Payment History" width="22" />
                        </div>
                      <span class="menu-link">Payment History</span>
                    </div>
                  </Link>
                </Menu.Item>
                )}
                {checkIfPermitted(Permissions.CAPTURE_INVOICE) && (
                  <Menu.Item key="/app/createinvoicesupplier">
                    <Link
                      to="/app/createinvoicesupplier"
                      className={`linkSideNav ${style.sideNavLink}`}
                    >
                      <div class={`d-flex ${style.collpaseOpacity}`}>
                      <div class="d-flex justify-content-center icon-wrapper">
                        <img src={createInvoiceIc} 
                        class={style.subMenuIcon} alt="Create Invoice" width="16" />
                        </div>
                      <span class="menu-link">Create Invoice (Product)</span>
                    </div>
                    </Link>
                  </Menu.Item>
                )}
                { checkIfPermitted(Permissions.VIEW_INVOICE) && (
                <Menu.Item key="/app/invoicelist">
                  <Link
                    to="/app/invoicelist"
                    className={`linkSideNav ${style.sideNavLink}`}
                  >
                    <div class={`d-flex ${style.collpaseOpacity}`}>
                      <div class="d-flex justify-content-center icon-wrapper">
                        <img src={invoiceListIc} 
                        class={style.subMenuIcon} alt="Invoice List" width="18" />
                        </div>
                      <span class="menu-link">Invoice List</span>
                    </div>
                  </Link>
                </Menu.Item>)}
              </SubMenu>
            )}

            {/* {system_role == 1 && (
              <SubMenu
                key="sub5"
                title={
                  <span className={style.collpaseOpacity}>
                    <img
                      src={billingIc}
                      className={style.sidebarIcon}
                      alt="Payments"
                      width="11"
                    />
                    <span className="collapse-hide">Billing</span>
                  </span>
                }
              > */}
            {/* <Menu.Item key="14">
                  <Link
                    className={`linkSideNav ${style.sideNavLink}`}
                    to="/app/invoicedetails"
                  >
                    <img
                      src={sendPaymentIc}
                      className={style.subMenuIcon}
                      width="22"
                    />
                    View Billings/Invoice
                  </Link>
                </Menu.Item> */}
            {/* <Menu.Item key="/app/createinvoicesupplier">
                  <Link
                    to="/app/createinvoicesupplier"
                    className={`linkSideNav ${style.sideNavLink}`}
                  >
                    <img
                      src={receivePaymentsIc}
                      className={style.subMenuIcon}
                      width="22"
                    />
                    Create Invoice
                  </Link>
                </Menu.Item>
                <Menu.Item key="/app/invoicelist">
                  <Link
                    to="/app/invoicelist"
                    className={`linkSideNav ${style.sideNavLink}`}
                  >
                    <img
                      src={receivePaymentsIc}
                      className={style.subMenuIcon}
                      width="22"
                    />
                    Invoice List
                  </Link>
                </Menu.Item> */}
            {/* </SubMenu>
            )} */}

            <SubMenu
              key="sub6"
              title={
                <div class={`d-flex ${style.collpaseOpacity}`}>
                  <div class="d-flex justify-content-center icon-wrapper">
                    <img src={inventoryIc} 
                    class={style.sidebarIcon} alt="Inventory" width="16" />
                    </div>
                  <span class="menu-link">Inventory</span>
                </div>
              }
            >
              { checkIfPermitted(Permissions.TRACK_INVENTORY) && (
              <Menu.Item key="/app/inventorysummery">
                <Link
                  to="/app/inventorysummery"
                  className={`linkSideNav ${style.sideNavLink}`}
                >
                   <div class={`d-flex ${style.collpaseOpacity}`}>
                      <div class="d-flex justify-content-center icon-wrapper">
                        <img src={inventorySumm} 
                        class={style.subMenuIcon} alt="Track Inventory" width="18" />
                        </div>
                      <span class="menu-link">Track Inventory</span>
                    </div>
                </Link>
              </Menu.Item>)}
              { checkIfPermitted(Permissions.LOAD_INVENTORY) && (
              <Menu.Item key="/app/addsupply">
                <Link
                  to="/app/addsupply"
                  className={`linkSideNav ${style.sideNavLink}`}
                >
                  <div class={`d-flex ${style.collpaseOpacity}`}>
                      <div class="d-flex justify-content-center icon-wrapper">
                        <img src={addSupplyIc} 
                        class={style.subMenuIcon} alt="Add Product" width="18" />
                        </div>
                      <span class="menu-link">Add Product</span>
                    </div>
                </Link>
              </Menu.Item>)}
              {checkIfPermitted(Permissions.VIEW_INVENTORY) && (
              <Menu.Item key="/app/inventorylist">
                <Link
                  to="/app/inventorylist"
                  className={`linkSideNav ${style.sideNavLink}`}
                >
                  <div class={`d-flex ${style.collpaseOpacity}`}>
                      <div class="d-flex justify-content-center icon-wrapper">
                        <img src={inventoryListIc} 
                        class={style.subMenuIcon} alt="Products List" width="18" />
                        </div>
                      <span class="menu-link">Products List</span>
                    </div>
                </Link>
              </Menu.Item>)}
              <Menu.Item key="/app/addsubcategory">
                <Link
                  to="/app/addsubcategory"
                  className={`linkSideNav ${style.sideNavLink}`}
                >
                  <div class={`d-flex ${style.collpaseOpacity}`}>
                      <div class="d-flex justify-content-center icon-wrapper">
                        <img src={subategoryIc} 
                        class={style.subMenuIcon} alt="Add Sub Category" width="18" />
                        </div>
                      <span class="menu-link">Add Sub Category</span>
                    </div>
                </Link>
              </Menu.Item>
              <Menu.Item key="/app/subcategorieslist">
                <Link
                  to="/app/subcategorieslist"
                  className={`linkSideNav ${style.sideNavLink}`}
                >
                  <div class={`d-flex ${style.collpaseOpacity}`}>
                      <div class="d-flex justify-content-center icon-wrapper">
                        <img src={subCatListIc} 
                        class={style.subMenuIcon} alt="Sub Categories List" width="18" />
                        </div>
                      <span class="menu-link">Sub Categories List</span>
                    </div>
                </Link>
              </Menu.Item>
              <Menu.Item key="/app/inventoryaudit">
                <Link
                  to="/app/inventoryaudit"
                  className={`linkSideNav ${style.sideNavLink}`}
                >
                  <div class={`d-flex ${style.collpaseOpacity}`}>
                      <div class="d-flex justify-content-center icon-wrapper">
                        <img src={inventoryAuditTrailIc} 
                        class={style.subMenuIcon} alt="Inventory Audit Trail" width="18" />
                        </div>
                      <span class="menu-link">Inventory Audit Trail</span>
                    </div>
                </Link>
              </Menu.Item>
            </SubMenu>
            {/* {(system_role == 1 || checkIfPermitted(Permissions.VIEW_SYSTEM_USERS)) && (
            <SubMenu
              key="sub7"
              title={
                <div class={`d-flex ${style.collpaseOpacity}`}>
                <div class="d-flex justify-content-center icon-wrapper">
                  <img src={userManagementIc} 
                  class={style.sidebarIcon} alt="User Management" width="16" />
                  </div>
                <span class="menu-link">User Management</span>
              </div>
              }
            >
              {checkIfPermitted(Permissions.VIEW_SYSTEM_USERS) && (
                <Menu.Item key="/app/users">
                  <Link
                    to="/app/users"
                    className={`linkSideNav ${style.sideNavLink}`}
                  >
                     <div class={`d-flex ${style.collpaseOpacity}`}>
                      <div class="d-flex justify-content-center icon-wrapper">
                        <img src={sidebarUsers} 
                        class={style.subMenuIcon} alt="Users" width="18" />
                        </div>
                      <span class="menu-link">Users</span>
                    </div>
                     </Link>
                </Menu.Item>
              )}
              {(JSON.parse(localStorage.getItem("USER_INFO")).systemRole == 1) && (
                <Menu.Item key="/app/userrolelist">
                  <Link
                    to="/app/userrolelist"
                    className={`linkSideNav ${style.sideNavLink}`}
                  >
                    <div class={`d-flex ${style.collpaseOpacity}`}>
                      <div class="d-flex justify-content-center icon-wrapper">
                        <img src={sidebarUsers} 
                        class={style.subMenuIcon} alt="User Roles" width="18" />
                        </div>
                      <span class="menu-link">User Roles</span>
                    </div>
                     </Link>
                </Menu.Item>
              )}
            </SubMenu>)} */}
            {/* 
            <Menu.Item key="28">
              <Link
                to="/app/practicecompliance"
                className={`linkSideNav ${style.sideNavLink}`}
              >
                <img
                  src={practiceComIc}
                  className={style.sidebarIcon}
                  alt="Practice Compliance"
                  width="15"
                />
                <span className="menu-link">Practice Compliance</span>
              </Link>
            </Menu.Item> */}
            {(checkIfPermitted(Permissions.VIEW_AUDIT_TRAILS) ||
            checkIfPermitted(Permissions.VIEW_STATEMENT)) && (
            <SubMenu
              key="sub10"
              title={
                <div class={`d-flex ${style.collpaseOpacity}`}>
                      <div class="d-flex justify-content-center icon-wrapper">
                        <img src={reportIc} 
                        class={style.subMenuIcon} alt="Reports" width="16" />
                        </div>
                      <span class="menu-link">Reports</span>
                    </div>
              }
            >
             { checkIfPermitted(Permissions.VIEW_AUDIT_TRAILS) && ( 
             <Menu.Item key="/app/audittrail">
                <Link
                  to="/app/audittrail"
                  className={`linkSideNav ${style.sideNavLink}`}
                >
                  <div class={`d-flex ${style.collpaseOpacity}`}>
                      <div class="d-flex justify-content-center icon-wrapper">
                        <img src={auditTrailIc} 
                        class={style.sidebarIcon} alt="Audit Trail" width="16" />
                        </div>
                      <span class="menu-link">Audit Trail</span>
                    </div>
                 </Link>
              </Menu.Item>)}
              {checkIfPermitted(Permissions.VIEW_STATEMENT) && ( 
              <Menu.Item key="/app/statements">
                <Link
                  to="/app/statements"
                  className={`linkSideNav ${style.sideNavLink}`}
                >
                  <div class={`d-flex ${style.collpaseOpacity}`}>
                      <div class="d-flex justify-content-center icon-wrapper">
                        <img src={statementsIc} 
                        class={style.sidebarIcon} alt="Statements" width="16" />
                        </div>
                      <span class="menu-link">Statements</span>
                    </div>
                  </Link>
              </Menu.Item>
              )}
              <Menu.Item key="/app/reportsIncome">
                <Link
                  to="/app/reportsIncome"
                  className={`linkSideNav ${style.sideNavLink}`}
                >
                  <div class={`d-flex ${style.collpaseOpacity}`}>
                      <div class="d-flex justify-content-center icon-wrapper">
                        <img src={otherReportsIc} 
                        class={style.sidebarIcon} alt="Other Reports" width="16" />
                        </div>
                      <span class="menu-link">Other Reports</span>
                    </div>
                </Link>
              </Menu.Item>
            </SubMenu> 
            )}
            {system_role == 1 && (
              <SubMenu
                key="sub8"
                title={
                  <div class={`d-flex ${style.collpaseOpacity}`}>
                      <div class="d-flex justify-content-center icon-wrapper">
                        <img src={sidebarSettings} 
                        class={style.sidebarIcon} alt="Setting" width="16" />
                        </div>
                      <span class="menu-link">Setting</span>
                    </div>
                }
              >
                {checkIfPermitted(Permissions.VIEW_SYSTEM_USERS) && (
                <Menu.Item key="/app/users">
                  <Link
                    to="/app/users"
                    className={`linkSideNav ${style.sideNavLink}`}
                  >
                     <div class={`d-flex ${style.collpaseOpacity}`}>
                      <div class="d-flex justify-content-center icon-wrapper">
                        <img src={sidebarUsers} 
                        class={style.subMenuIcon} alt="Users" width="18" />
                        </div>
                      <span class="menu-link">Users</span>
                    </div>
                     </Link>
                </Menu.Item>
              )}
              {(this.state.systemRole == 1) && (
                <Menu.Item key="/app/userrolelist">
                  <Link
                    to="/app/userrolelist"
                    className={`linkSideNav ${style.sideNavLink}`}
                  >
                    <div class={`d-flex ${style.collpaseOpacity}`}>
                      <div class="d-flex justify-content-center icon-wrapper">
                        <img src={userRolesIc} 
                        class={style.subMenuIcon} alt="User Roles" width="18" />
                        </div>
                      <span class="menu-link">User Roles</span>
                    </div>
                     </Link>
                </Menu.Item>
              )}
                <Menu.Item key="/app/generalsetting">
                  <Link
                    to="/app/generalsetting"
                    className={`linkSideNav ${style.sideNavLink}`}
                  >
                    <div class={`d-flex ${style.collpaseOpacity}`}>
                      <div class="d-flex justify-content-center icon-wrapper">
                        <img src={generalSettingIc} 
                        class={style.subMenuIcon} alt="General Setting" width="16" />
                        </div>
                      <span class="menu-link">General Setting</span>
                    </div>
                  </Link>
                </Menu.Item>
                
                <Menu.Item key="/app/claimsettings">
                  <Link
                    to="/app/claimsettings"
                    className={`linkSideNav ${style.sideNavLink}`}
                  >
                    <div class={`d-flex ${style.collpaseOpacity}`}>
                      <div class="d-flex justify-content-center icon-wrapper">
                        <img src={claimSettingsIc} 
                        class={style.subMenuIcon} alt="Claim Settings" width="16" />
                        </div>
                      <span class="menu-link">Claim Settings</span>
                    </div>
                  </Link>
                </Menu.Item>

                { checkIfPermitted(Permissions.CONFIGURE_PICKLIST) && (
                  <Menu.Item key="/app/settings">
                    <Link
                      to="/app/settings"
                      className={`linkSideNav ${style.sideNavLink}`}
                    >
                      <div class={`d-flex ${style.collpaseOpacity}`}>
                      <div class="d-flex justify-content-center icon-wrapper">
                        <img src={picklistSettingIc} 
                        class={style.subMenuIcon} alt="Pick List Customization" width="16" />
                        </div>
                      <span class="menu-link">Pick List Customization</span>
                    </div>
                    </Link>
                  </Menu.Item>)}
                  
                  <Menu.Item key="/app/templates">
                    <Link
                      to="/app/templates"
                      className={`linkSideNav ${style.sideNavLink}`}
                    >
                      <div class={`d-flex ${style.collpaseOpacity}`}>
                      <div class="d-flex justify-content-center icon-wrapper">
                        <img src={smsTemplateIc} 
                        class={style.subMenuIcon} alt="SMS Template" width="16" />
                        </div>
                      <span class="menu-link">SMS Template</span>
                    </div>
                    </Link>
                  </Menu.Item>
              </SubMenu>
            )}

           {(checkIfPermitted(Permissions.UPDATE_PRACTITIONER_DETAILS) || 
           checkIfPermitted(Permissions.MANAGE_CREDENTIALS) )&& ( 
           <SubMenu
              key="sub9"
              title={
                <div class={`d-flex ${style.collpaseOpacity}`}>
                <div class="d-flex justify-content-center icon-wrapper">
                  <img src={myAccountIc} 
                  class={style.sidebarIcon} alt="My Account" width="16" />
                  </div>
                <span class="menu-link">My Account</span>
              </div>
              }
            >
            { checkIfPermitted(Permissions.UPDATE_PRACTITIONER_DETAILS) && ( 
            <Menu.Item key="/app/practicecompliance">
                <Link
                  to="/app/practicecompliance"
                  className={`linkSideNav ${style.sideNavLink}`}
                >
                      <div class={`d-flex ${style.collpaseOpacity}`}>
                        <div class="d-flex justify-content-center icon-wrapper">
                          <img src={practiceComIc}
                            class={style.sidebarIcon} alt="Practice Compliance" width="16" />
                        </div>
                        <span class="menu-link">Practice Compliance</span>
                      </div>
                </Link>
              </Menu.Item>)}
              {checkIfPermitted(Permissions.MANAGE_CREDENTIALS) && (
                <Menu.Item key="/app/editaccount">
                  <Link
                    to="/app/editaccount"
                    className={`linkSideNav ${style.sideNavLink}`}
                  >
                    <div class={`d-flex ${style.collpaseOpacity}`}>
                        <div class="d-flex justify-content-center icon-wrapper">
                          <img src={editAccountIc}
                            class={style.subMenuIcon} alt="Edit Account" width="16" />
                        </div>
                        <span class="menu-link">Edit Account</span>
                      </div>
                  </Link>
                </Menu.Item>
              )}
              <Menu.Item key="28">
                <Link
                  onClick={this.logoutClick}
                  className={`linkSideNav ${style.sideNavLink}`}
                >
                  <div class={`d-flex ${style.collpaseOpacity}`}>
                        <div class="d-flex justify-content-center icon-wrapper">
                          <img src={logoutIc}
                            class={style.subMenuIcon} alt="Log Out" width="16" />
                        </div>
                        <span class="menu-link">Log Out</span>
                      </div>
                </Link>
              </Menu.Item>
            </SubMenu>)}
          </Menu>
        </Sider>
      </Layout>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    notificationsData: state.notifications,
    dropdownListData: state.dropdownList,
    switchRolesData: state.switchRoles,
    userDetailsData: state.userDetails,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchNotificationsListing: () => dispatch(fetchNotificationsListing()),
    switchRoles: (role_id) => dispatch(switchRoles(role_id)),
    fetchUserDetails: (user_id)=> dispatch(fetchUserDetails(user_id))
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Sidebar));
//export default withRouter(Sidebar);
